import { render, staticRenderFns } from "./surface_app.vue?vue&type=template&id=5ce7242d&scoped=true&"
import script from "./surface_app.vue?vue&type=script&lang=ts&"
export * from "./surface_app.vue?vue&type=script&lang=ts&"
import style0 from "./surface_app.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./surface_app.vue?vue&type=style&index=1&id=5ce7242d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7242d",
  null
  
)

export default component.exports